/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 工资模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月22日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//员工档案
	employee: {
		list(params = {}) {
			return Ajax.get('/salary-employee', params)
		},
		save(p) {
			return Ajax.post('/salary-employee', p)
		},
		update(p) {
			return Ajax.put('/salary-employee', p)
		},
		delete(id) {
			return Ajax.delete(`/salary-employee/${id}`)
		}
	},
	//工资期间
	period: {
		list(params = {}) {
			return Ajax.get('/salary-period', params)
		},
		open(p) {
			return Ajax.post('/salary-period/open', p)
		},
		delete(id) {
			return Ajax.delete(`/salary-period/${id}`)
		}
	},
	//工资单
	bill: {
		load(year, month) {
			return Ajax.get('/salary-bill', {year, month})
		},
		save(p) {
			return Ajax.post('/salary-bill', p)
		},
		accrue(p) {
			return Ajax.post('/salary-bill/accrue', p)
		},
		accruePreview(p) {
			return Ajax.post('/salary-bill/accrue/preview', p)
		},
		pay(id) {
			return Ajax.post(`/salary-bill/pay/${id}`)
		},
		//应用五险一金到工资单
		applySocial(periodId) {
			return Ajax.post('/salary-bill/applySocial', null, {params: {periodId}})
		}
	},
	//五险一金设置
	social: {
		list(params = {}) {
			return Ajax.get('/social-security', params)
		},
		save(p) {
			return Ajax.post('/social-security', p)
		},
		update(p) {
			return Ajax.put('/social-security', p)
		},
		delete(id) {
			return Ajax.delete(`/social-security/${id}`)
		}
	}
};
